import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { useIntl } from 'react-intl'

export function PaymentTitle() {
  const intl = useIntl()

  return (
    <Typography as="h1" variant="display-e-regular">
      {intl.formatMessage({ id: 'payment_scope_booking_payment_page_title' })}
    </Typography>
  )
}
